<template>
  <section class="documentation">
      <!--
      <div v-if="!isProduction()" class="hero is-warning">
        <div class="hero-body hero-lite is-paddingless">

          <div class="container is-fullhd">
            <h2 class="title is-4 is-paddingless is-marginless has-text-centered">ESTA ES UNA VERSIÓN DE PRUEBA</h2>
          </div>
        </div>
      </div>-->
    <TopBanner :visible="showBanner" />
    <TheHeader ref="header"/>
      <div class="hero is-primary">
        <div>
          <div class="container is-fullhd">
            <!--NAVEGADOR DESKTOP-->
            <div v-show="!isMobile" class="columns" style="margin: 0px;">
              <div class="column is-3 center-vertical">
                <router-link style="margin: 0 auto;"
                  to="/"
                  class="navbar-item"
                  active-class="">
                  <img 
                      :src="imagen"
                      alt="CERTIFAKT">
                </router-link>
              </div>
              <div class="column is-5 is-hidden-mobile" 
                style="display: flex; justify-content: center; align-items: center; flex-direction: column;">
                <div style="display: flex; gap: 10px;">
                  <p class="title is-5" style="margin: 0;">{{ getUser.razonSocial }}</p>
                  <p> - </p>
                  <p class="is-5">{{ getUser.ruc }}</p>
                </div>
                <p class="subtitle is-hidden-touch">{{ subtitle }}</p>
              </div>
              <div class="column is-4 is-right center-vertical" style="padding:2px;">
                <div class="columns is-mutiline is-mobile" style="display: flex; align-items: center; margin: 0px; width: 100%;">
                  <div class="">
                    <b-field type="is-white" class="navbar-item" style="display: flex;">
                      <select class="select-vue" v-model="oficinaSelected" :disabled="disabledOfi()" expanded placeholder="Seleccione punto de venta" rounded>
                        <option
                          v-for="(option, i) in oficinasOptions"
                          :value="option.value"
                          :key="i">
                          {{ option.text }}
                        </option>
                      </select>
                    </b-field>
                  </div>
                  <b-dropdown position="is-bottom-left" v-if="userIsAdmin" class="navbar-item">
                    <button class="button is-outlined is-default" slot="trigger">
                      <b-icon icon="bell"></b-icon>
                    </button>
                    <b-dropdown-item
                      v-for="notification in notifications"
                      :key="notification.id"
                      @click="alertNotificationView(notification)">
                      <article class="notification" :class="{ 'not-show': dateLastSeenNotifications.getTime() < notification.createdOn.getTime() }">
                        <b-icon icon="arrow-down" type="is-warning" size="is-large"></b-icon>
                        <p class="notification__message"> {{ notification.description }} </p>
                        <span class="notification__ago"> {{ notification.ago }} </span>
                      </article>
                    </b-dropdown-item>
                  </b-dropdown>
                  <b-dropdown position="is-bottom-left" v-if="userIsAdmin" class="navbar-item" >
                    <button class="button is-outlined is-default" slot="trigger">
                      <b-icon icon="tune"></b-icon>
                    </button>
                    <b-dropdown-item @click="goRoute('/admin/datos-principales')">Datos principales</b-dropdown-item>
                    <b-dropdown-item @click="goRoute('/admin/puntos-venta')">Puntos de venta</b-dropdown-item>
                    <b-dropdown-item @click="goRoute('/admin/unidad-medida')">Unidades de medida</b-dropdown-item>
                    <b-dropdown-item @click="goRoute('/admin/cuentas-bancarias')">Cuentas bancarias</b-dropdown-item>
                    <b-dropdown-item @click="goRoute('/admin/mis-emails')">Mis Emails</b-dropdown-item>
                  </b-dropdown>
                  <b-dropdown position="is-bottom-left" v-if="getUser" class="navbar-item">
                    <button class="button is-outlined is-default" slot="trigger">
                      <b-icon icon="account-circle"></b-icon>
                    </button>
                    <b-dropdown-item @click="goRoute('/principal/cuenta')">Mi cuenta - {{ getUser.fullName }}</b-dropdown-item>
                    <b-dropdown-item @click="goRoute('/admin/cambio-clave')">Cambiar Contraseña</b-dropdown-item>
                    <b-dropdown-item @click="cerrarSesion">Cerrar sesión</b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>
            </div>
            <!--NAVEGADOR MOBILE-->
            <div v-show="isMobile" class="columns is-mobile hero-lite">
              <div class="column is-2" style="display: flex; align-items: center; justify-content: center;">
                <div class="is-hidden-desktop">
                  <TheSidebar :data="menu"/>
                </div>
              </div>
              <div class="column is-8 has-text-centered" style="display: flex; align-items: center; justify-content: center;">
                <router-link style="margin: 0 auto;"
                  to="/"
                  class="navbar-item"
                  active-class="">
                  <img
                      :src="imagen"
                      alt="CERTIFAKT">
                </router-link>
              </div>
              <div class="column is-2 has-text-centered" style="display: flex; align-items: center; justify-content: center;">
                <div class="is-hidden-desktop">
                  <b-dropdown position="is-bottom-left">
                    <!-- Botón principal -->
                    <button slot="trigger"
                            style="padding: 10px 15px; border-radius: 20px; border: none;">
                      <p class="title is-5" style="margin: 0; color: darkslateblue;">
                        {{ getUser.razonSocial.charAt(0).toUpperCase() }}
                      </p>
                    </button>

                    <!-- Iterar menús -->
                    <div v-for="(menu, i) in menus" :key="i">

                      <!-- 🔹 Caso con subitems -->
                      <b-dropdown-item v-if="menu.subitems" custom>
                        <b-dropdown position="is-bottom-right" append-to-body >
                          <!-- Botón que abre el submenú -->
                          <b-button class="button is-light" slot="trigger">
                            <div class="media" style="padding: 6px 5px;">
                              <b-icon class="media-left" :icon="menu.icon"></b-icon>
                              <div class="media-content">
                                <h3>{{ menu.text }} ▸</h3>
                              </div>
                            </div>
                          </b-button>

                          <!-- Subitems -->
                          <b-dropdown-item
                            v-for="(sub, subIndex) in menu.subitems"
                            :key="subIndex"
                            @click="handleClick(sub)"
                          >
                            <div class="media" style="padding: 6px 5px;">
                              <b-icon class="media-left" :icon="sub.icon"></b-icon>
                              <div class="media-content">
                                <h3>{{ sub.text }}</h3>
                              </div>
                            </div>
                            <div class="media" style="padding: 6px 5px;" v-if="menu.text === 'Mi cuenta'">
                              <b-icon class="media-left" icon="logout"></b-icon>
                              <div class="media-content" @click="cerrarSesion()">
                                <h3>Cerrar Sesión</h3>
                              </div>
                            </div>
                          </b-dropdown-item>
                        </b-dropdown>
                      </b-dropdown-item>

                      <!-- 🔹 Caso sin subitems -->
                      <b-dropdown-item v-else @click="handleClick(menu)">
                        <div class="media" style="padding: 6px 5px;">
                          <b-icon class="media-left" :icon="menu.icon"></b-icon>
                          <div class="media-content">
                            <h3>{{ menu.text }}</h3>
                          </div>
                        </div>
                      </b-dropdown-item>
                    </div>
                  </b-dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <main class="main">
          <router-view/>
      </main>
    <TheFooter/>
  </section>
</template>

<script>
    import TheHeader from './TheHeader'
    import TheFooter from './TheFooter'
    import {mapGetters, mapMutations} from 'vuex'
    import Methods from '../api/methods'
    import es from 'javascript-time-ago/locale/es'
    import TimeAgo from "javascript-time-ago";
    import TopBanner from './TopBanner.vue'
    import TheSidebar from '../pages/TheSidebar.vue'
    import menu from '../menu'

    TimeAgo.addLocale(es);
    TimeAgo.addDefaultLocale(es);

    export default {
        components: {
    TheHeader,
    TheFooter,
    TopBanner,
    TheSidebar
},
        data(){
          return{
            isMobile: false,
            idImagen: 100,
            oficinas:[],
            subtitle: 'Facturación electrónica',
            notifications: [],
            intervalNotification: null,
            dateLastSeenNotifications: null,
            recargarNotificacionesMilisegundos: __RECARGAR_NOTIFICACIONES_MILISEGUNDOS__,
            currentMenu: { icon: 'account-group', text: 'People' },
            menus: [
              { 
                icon: 'store', 
                text: 'Mi empresa', 
                subitems: [
                  { icon: 'briefcase', text: 'Datos principales', route: '/admin/datos-principales' },
                  { icon: 'map-marker', text: 'Puntos de venta', route: '/admin/puntos-venta' },
                  { icon: 'scale-balance', text: 'Unidades de medida', route: '/admin/unidad-medida' },
                  { icon: 'credit-card', text: 'Cuentas bancarias', route: '/admin/cuentas-bancarias' }
                ]
              },
              { 
                icon: 'account-circle',
                text: 'Mi cuenta',
                subitems: [
                  //{ icon: 'account-edit', text: 'Editar perfil', route: '/principal/cuenta' },
                  { icon: 'lock', text: 'Cambiar contraseña', route: '/admin/cambio-clave' },
                  //{ icon: 'logout', text: 'Cerrar Sesión', route: '/admin/cerrar-sesion' }
                ]
              },
              { 
                icon: 'bell', 
                text: 'Notificaciones',
                subitems: [
                  { icon: 'email-outline', text: 'Ver todas', route: '/notificaciones' },
                  { icon: 'check', text: 'Marcar como leídas', action: 'marcarLeidas' }
                ]
              },
              { 
                icon: 'settings', 
                text: 'Configuration',
                subitems: [
                  { icon: 'email', text: 'Mis Emails', route: '/admin/mis-emails' },
                ]
              }
            ]
          }
        },
      computed:{
        ...mapGetters({'getUser':'auth/getUser'}),
        ...mapGetters({'getUser':'auth/getUser'}),
        ...mapGetters({'getIdPuntoVenta':'auth/getIdPuntoVenta'}),
        ...mapGetters({'getPuntoVenta':'punto/getPuntoVenta'}),
        ...mapGetters({'getCompany':'auth/getCompany'}),
        oficinasOptions(){
          const listaOptions = []
          listaOptions.push({value:null,text:"Seleccione punto de venta"})
          this.oficinas.forEach(ofi=>{
            listaOptions.push({value:ofi,text:ofi.nombreCorto})
          })
          return listaOptions
        },
        oficinaSelected: {
          set(value){
            this.setPuntoVenta(value)
          },
          get(){
            return this.getPuntoVenta
          }
        },
        userIsAdmin(){
          return this.getUser.typeUser == '01'
        },
        menu() {
          return menu
        },
        imagen(){
          return this.getCompany && this.getCompany.isClientCertifact
            ? "https://certifakt.s3-us-west-2.amazonaws.com/logo_certifakt_text_2.png"
            : "https://certifakt.s3-us-west-2.amazonaws.com/logo_certifakt_text.png"
        }
      },
      methods:{
        ...mapMutations({'setPuntoVenta':'punto/setPuntoVenta'}),
        alertNotificationView(notification) {
          if(this.dateLastSeenNotifications.getTime() < notification.createdOn.getTime()) {
            Methods.doPost(this, 'api/notifications/alert-notification-view', { date: notification.createdOnString })
              .then(() => {
                this.dateLastSeenNotifications = notification.createdOn;
              })
          }
        },
        obtenerNotificaciones() {
          Methods.doGet(this, `api/notifications?limite=10`)
            .then(({notifications, dateLastSeenNotifications}) => {

              this.dateLastSeenNotifications = new Date(dateLastSeenNotifications);
              const timeAgo = new TimeAgo('es-ES');

              this.notifications = notifications.map(notification => ({
                id: notification.id,
                description: notification.descripcion,
                createdOnString: notification.createdOn,
                createdOn: new Date(notification.createdOn),
                ago: timeAgo.format(new Date(notification.createdOn))
              }));

            });
        },
        cargarOficinas(){
          return new Promise((resolve, reject) => {
            const url = `api/oficinas`
            Methods.doGet(this,url).then(data=>{
              this.oficinas=data
              resolve()
            }).catch(error=>reject(error))
          })
        },
        isProduction(){
          return this.$isProduction
        },
        disabledOfi(){
          if(this.getIdPuntoVenta){
            return true;
          }else{
            return false;
          }
        },
        goRoute(ruta){
          this.$router.push(ruta)
        },
        cerrarSesion(){
          location.reload()
          localStorage.clear()
          this.$router.push("/login")
        },
        handleClick(menu) {
          console.log('Seleccionaste item:', menu.text)
            if (menu.route) {
              this.$router.push(menu.route)
            }
            //this.parentOpen = false
            //this.childOpen = {}
        },
        checkDevice() {
          this.isMobile = window.innerWidth < 1024; // < 1024px = móvil según Bulma
        },
      },
      mounted(){
        this.checkDevice();
        window.addEventListener('resize', this.checkDevice);
        this.obtenerNotificaciones();
        this.intervalNotification = setInterval(() => {
          this.obtenerNotificaciones();
        }, this.recargarNotificacionesMilisegundos || 1800000);
      },
      beforeDestroy() {
        window.removeEventListener('resize', this.checkDevice);
        if (this.intervalNotification) {
          clearInterval(this.intervalNotification);
        }
      },
      beforeMount(){
        this.cargarOficinas().then(()=>{
          if(this.getIdPuntoVenta){
            const ofs = this.oficinas.find(ofi=>ofi.id==this.getIdPuntoVenta)
            this.oficinaSelected = ofs
            localStorage.setItem("ofs",JSON.stringify(ofs))
          }
        })
      }

    }
</script>

<style scoped>
  .hero {
    padding: 5px;
  }
  .center-vertical{
    padding:0px; 
    display: flex; 
    align-items: center;
    justify-content: center;
    flex-direction: row;
  }

  .hero-lite{
    padding: 0.9rem 0.5rem;
  }

  .documentation {
    padding: 0px;
  }
  .select-vue{
  width: 100%;border-radius: 10px;outline: none;font-size: 16px;
  border: 1px solid #ccc;
  padding-left: 10px;
  padding-top: 3px;
  padding-bottom: 3px;
}
  .notification {
    width: 475px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    padding: 0.5rem 1rem;
  }

  .notification.not-show {
    border-left: 4px solid #007bea;
  }

  .notification__message {
    width: 85%;
    word-wrap: break-word; /* O usa overflow-wrap: break-word; */
    white-space: normal;
  }

  .notification__ago {
    font-size: 12px;
  }

</style>



// WEBPACK FOOTER //
// DefaultTemplate.vue?7757ceda